/** Validações espelhadas do backend (convite Assina). */

export function digitsOnly(s) {
  return String(s || '').replace(/\D/g, '');
}

export function isValidCpf(d) {
  const c = digitsOnly(d);
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(c[i], 10) * (10 - i);
  let d1 = (sum * 10) % 11;
  if (d1 === 10) d1 = 0;
  if (d1 !== parseInt(c[9], 10)) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(c[i], 10) * (11 - i);
  let d2 = (sum * 10) % 11;
  if (d2 === 10) d2 = 0;
  return d2 === parseInt(c[10], 10);
}

export function isValidCnpj(cnpj) {
  const c = digitsOnly(cnpj);
  if (c.length !== 14 || /^(\d)\1+$/.test(c)) return false;
  let length = 12;
  let numbers = c.substring(0, length);
  let sum = 0;
  let pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i), 10) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(c.charAt(12), 10)) return false;
  length = 13;
  numbers = c.substring(0, length);
  sum = 0;
  pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i), 10) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  return result === parseInt(c.charAt(13), 10);
}

export function nomeCompletoMatches(cadastrado, informado) {
  const norm = (s) =>
    s
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  return norm(cadastrado) === norm(informado);
}

/** CPF (11) ou CNPJ (14) com dígitos verificadores válidos. */
export function isCpfOuCnpjValido(val) {
  const d = digitsOnly(val);
  if (d.length === 11) return isValidCpf(d);
  if (d.length === 14) return isValidCnpj(d);
  return false;
}
